import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import Routers from "./Routes";
import { fetchSystemConfigsAndCustomTabs } from "./sharedFunctions/SystemConfig";

function App() {
  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    const token =
      localStorage.getItem("appToken") ||
      localStorage.getItem("apptoken") ||
      localStorage.getItem("token");

    if (isLoggedIn && token) {
      fetchSystemConfigsAndCustomTabs();
    }
  }, []);

  return (
    <>
      <Routers />
      <ToastContainer />
    </>
  );
}

export default App;
